import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-direct.png'


const _withScopeId = n => (_pushScopeId("data-v-045d1ed7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-group" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "bottom" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "왼쪽 화살표"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.executeButton(_ctx.command))),
    type: "button",
    class: "shadow"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.subTitle), 1)
    ]),
    _hoisted_4
  ]))
}